import axios from 'axios';

// 获取今日计划
export const fetchDailyPlan = async () => {
    try {
        console.log('获取今日计划...');
        const response = await axios.get('/dailyplans/today');
        console.log('获取成功:', response.data);
        return response.data;
    } catch (error) {
        console.error('获取今日计划时出错:', error);
        throw error;
    }
};

// 获取目标列表
export const fetchGoals = async () => {
    try {
        console.log('获取目标列表...');
        const response = await axios.get('/dailyplans/goals');
        console.log('获取成功:', response.data);
        return response.data;
    } catch (error) {
        console.error('获取目标列表时出错:', error);
        throw error;
    }
};

// 获取目标下的任务列表
export const fetchTasks = async (goalId) => {
    try {
        console.log(`获取目标 ${goalId} 下的任务列表...`);
        const response = await axios.get(`/dailyplans/goals/${goalId}/tasks`);
        console.log(`目标 ${goalId} 的任务获取成功:`, response.data);
        return response.data;
    } catch (error) {
        console.error(`获取目标 ${goalId} 下的任务列表时出错:`, error);
        throw error;
    }
};

// 添加任务到今日计划
export const addTaskToDailyPlan = async (goalId, taskId) => {
    try {
        console.log(`将任务 ${taskId} 添加到目标 ${goalId} 的今日计划...`);
        const response = await axios.post('/dailyplans/add-task', { goalId, taskId });
        console.log('任务添加成功:', response.data);
        return response.data;
    } catch (error) {
        console.error(`将任务 ${taskId} 添加到今日计划时出错:`, error);
        throw error;
    }
};

// 从今日计划中移除任务
export const removeTaskFromDailyPlan = async (goalId, taskId) => {
    try {
        console.log(`从今日计划中移除目标 ${goalId} 下的任务 ${taskId}...`);
        const response = await axios.post('/dailyplans/remove-task', { goalId, taskId });
        console.log('任务移除成功:', response.data);
        return response.data;
    } catch (error) {
        console.error(`移除任务 ${taskId} 时出错:`, error);
        throw error;
    }
};

// 更新任务备注
export const updateTaskNote = async (goalId, taskId, notes) => {
    try {
        console.log(`更新目标 ${goalId} 下任务 ${taskId} 的备注...`);
        const updatedTask = { notes };
        await axios.put(`/goals/${goalId}/tasks/${taskId}`, updatedTask);
        console.log(`任务 ${taskId} 的备注更新成功`);
    } catch (error) {
        console.error(`更新任务 ${taskId} 的备注时出错:`, error);
        throw error;
    }
};

// 清除所有今日计划
export const clearDailyPlans = async () => {
    try {
        console.log('清除所有今日计划...');
        const response = await axios.post('/dailyplans/clear-dailyplans');
        console.log('清除成功:', response.data);
        return response.data;
    } catch (error) {
        console.error('清除今日计划时出错:', error);
        throw error;
    }
};

// 更新今日总结
export const updateDailySummary = async (summary) => {
    try {
        console.log('更新今日总结...');
        const response = await axios.post('/dailyplans/update-daily-summary', summary);
        console.log('今日总结更新成功:', response.data);
        return response.data;
    } catch (error) {
        console.error('更新今日总结时出错:', error);
        throw error;
    }
};
